import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { constants } from '@well/infra/constants';
import { PlatformLegalEntityInvoicingTermsDto } from '@well/platform-administration/company/domain';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { BsInputTextDirective, BsInputNumberComponent } from '@well/iriro-frontend-libs/bs-component-store';

@Component({
    selector: 'well-platform-legal-entity-invoicing-terms-inputs',
    imports: [FloatLabel, FormsModule, TranslateModule, BsInputTextDirective, BsInputNumberComponent, FormInlineErrorDirective],
    templateUrl: './platform-legal-entity-invoicing-terms-inputs.component.html',
    styleUrls: ['./platform-legal-entity-invoicing-terms-inputs.component.scss'],
    viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformLegalEntityInvoicingTermsInputsComponent {

  @Input() platformLegalEntityInvoicingTermsDTO: PlatformLegalEntityInvoicingTermsDto = new PlatformLegalEntityInvoicingTermsDto();

}
